import * as React from 'react';
import { Grid, Dialog, Typography } from '@material-ui/core';
import ConfirmButton from '../../../../ui-components/Button/ConfirmButton';
import UndoButton from '../../../../ui-components/Button/UndoButton';

interface IProps {
    open: boolean;
    onClose: () => any;
    classes: any;
    approve: () => any;
}
export const AlertApproval = (props: IProps) => {
    return (
        <Dialog maxWidth={'lg'} open={props.open} onClose={props.onClose}>
            <Grid container className={props.classes.approvePopupContainer}>
                <Grid item sm={12} style={{
                    display: 'flex',
                    justifyContent: 'center'
                }}>
                    <Typography variant='h6'>Approva pianificazione</Typography>
                </Grid>
                <Grid item sm={12}>
                </Grid>
                <Grid item sm={12} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column'
                }}>
                    <Typography>Le attività pianificate saranno visibili per tutti gli utenti</Typography>
                    <Typography>Non potrai modificare nome, descrizione e categoria</Typography>
                    <Typography>Non potrai modificare i trainer</Typography>
                </Grid>
            </Grid>
            <Grid item sm={12} className={props.classes.buttonsContainer}>
                <ConfirmButton text='Approva' onClick={props.approve} />
                <UndoButton text='Annulla' onClick={props.onClose} />
            </Grid>
        </Dialog>
    );
}
